import { getColor } from '@/helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { MdCheck, MdContentCopy, MdOutlineOpenInNew } from 'react-icons/md';

type UrlProps = {
  url?: string | null;
};

const Url = ({ url }: UrlProps) => {
  const [copied, setCopied] = useState(false);
  const urlFormater = () => {
    if (url?.startsWith('https://'))
      return (
        <>
          <FontAwesomeIcon
            size="sm"
            icon={'lock'}
            title="https"
            color={getColor('success')}
          />
          <span className="url-text">{url.replace('https://', '')}</span>
        </>
      );
    else if (url?.startsWith('http://'))
      return (
        <>
          <FontAwesomeIcon
            size="sm"
            icon={'lock-open'}
            title="http"
            color={getColor('danger')}
          />
          <span className="url-text">{url.replace('http://', '')}</span>
        </>
      );
    else {
      return <div></div>;
    }
  };

  return (
    <div
      className="text-end d-flex gap-1 align-items-center"
      style={{ direction: 'ltr' }}
    >
      <style>
        {`
        .url-text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          max-width: 250px; /* Adjust based on your layout */
          vertical-align: bottom; /* Align the text vertically with icons */
        }

        `}
      </style>
      {url && (
        <>
          <div className="d-flex fs-0 gap-1 align-items-baseline">
            {urlFormater()}
          </div>
          <div>
            {copied ? (
              <MdCheck size={18} />
            ) : (
              <MdContentCopy
                title="کپی پیوند"
                onClick={() => {
                  navigator.clipboard.writeText(url).then(() => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 3000);
                  });
                }}
                className="cursor-pointer little-icon"
                style={{ paddingLeft: '3px' }}
                size={18}
              />
            )}
            <MdOutlineOpenInNew
              title="بازکردن پیوند"
              onClick={() => window.open(url, '_blank')}
              className="cursor-pointer little-icon"
              style={{ paddingLeft: '3px' }}
              size={18}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Url;
